<template>
  <div>
    <!-- {{formId}} -->
    <div>
      <h2>{{ $t("checklist.form.Draft") }}</h2>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" msg="Formulário não exluido" />
    </div>
    <div>
      <b-table
        ref="MyForm"
        class="table-nowrap"
        :busy.sync="isBusy"
        :filter-debounce="500"
        :items="myProvider"
        :fields="computedFields"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
        :filter="tableFilters"
      >
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th v-for="field in fields" :key="field.key">
              <!-- {{ field }} -->
              <div v-if="field.key != 'actions'" class="filterActive">
                <b-form-select
                  v-if="field.key == 'active'"
                  :options="optionsBoolean"
                  v-model="tableFilters[field.key]"
                >
                </b-form-select>
                <b-form-input
                  v-else-if="field.key == 'dateFill'"
                  type="date"
                  v-model="tableFilters[field.key]"
                />
                <b-form-select
                  v-else-if="field.key == 'schedulerStatus'"
                  :options="statusOpt"
                  v-model="tableFilters[field.key]"
                >
                </b-form-select>
                <b-form-input
                  v-else
                  v-model="tableFilters[field.key]"
                  :placeholder="'Buscar por ' + field.label"
                />
              </div>

              <div v-else>
                <!-- {{ showAllDraft }} -->
                <div v-if="isUserAdmin">
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="showAllDraft"
                    name="checkbox-1"
                    :value="true"
                  >
                    Exibir todos os rascunhos
                  </b-form-checkbox>
                </div>
              </div>
            </b-th>
          </b-tr>
        </template>
        <template v-slot:cell(actions)="data">
          <!-- {{data}} -->
          <b-col class="buttons">
            <div class="table-buttons-desktop">
              <router-link :to="getFillUrl(data.item)">
                <b-button
                  size="sm"
                  v-b-tooltip.hover
                  :title="$t('checklist.form.continueFillingTooltip')"
                >
                  {{ $t("checklist.form.continueFilling") }}
                </b-button>
              </router-link>

              <b-button
                v-if="data.item.active == 'Sim'"
                size="sm"
                class="ml-2"
                v-b-tooltip.hover
                :title="$t('checklist.form.deleteDraftTooltip')"
                @click="deleteDraftShowDialog(data.item.checklistId)"
              >
                {{ $t("checklist.form.deleteDraft") }}
              </b-button>
              <b-button
                v-if="data.item.active == 'Não'"
                size="sm"
                class="ml-2"
                v-b-tooltip.hover
                title="Reativar"
                @click="reactivateDraftShowDialog(data.item.checklistId)"
              >
                Reativar
              </b-button>

              <router-link :to="getUserChangeUrl(data.item)">
                <b-button
                  size="sm"
                  class="ml-2"
                  v-b-tooltip.hover
                  :title="$t('checklist.form.userChangeTooltip')"
                >
                  {{ $t("checklist.form.userChange") }}
                </b-button>
              </router-link>
            </div>
            <div class="table-buttons-mobile">
              <router-link :to="getFillUrl(data.item)">
                <i class="material-icons">edit</i>
              </router-link>

              <a href="#" @click="deleteDraft(data.item.checklistId)">
                <i class="material-icons ml-4">delete</i>
              </a>

              <router-link :to="getUserChangeUrl(data.item)">
                <i class="material-icons ml-4">manage_accounts</i>
              </router-link>
            </div>
          </b-col>
        </template>
      </b-table>
    </div>
    <table-pagination-props
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :perPage.sync="tablePerPage"
      :rowCount.sync="tableRowCount"
    >
    </table-pagination-props>
    <base-dialog-confirm
      ref="deleteDraftDialog"
      :message="$t('checklist.form.deleteDraftConfirm')"
      :title="$t('checklist.form.deleteDraftConfirm')"
      @confirm="deleteDraft"
    >
    </base-dialog-confirm>
    <base-dialog-confirm
      ref="reactivateDraftDialog"
      message="Deseja reativar o checklist?"
      title="Reativar checklist"
      @confirm="reactivateDraft"
    >
    </base-dialog-confirm>
  </div>
</template>

<script>
import BaseDialogConfirm from "@/components_rms/base/BaseDialogConfirm.vue";
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";

export default {
  components: {
    BaseDialogConfirm,
    FadeAlertDanger,
    SuccessFadeAlert,
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
  },
  props: {
    formId: String,
    moduleId: String,
  },
  data: function () {
    return {
      alert: {
        success: "Checklist descartado com sucesso",
      },
      fields: [
        {
          key: "actions",
          sortable: false,
          label: "",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "checklistId",
          sortable: false,
          label: "Checklist",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "dateFill",
          sortable: false,
          label: "Data de salvamento",
          formatter: (value, key, item) => {
            if (item.dateFill) {
              let date = new Date(item.dateFill);
              return date.toLocaleString();
            }
            return "";
          },
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "formName",
          sortable: false,
          label: "Formulário",
        },
        {
          key: "searchKey",
          sortable: false,
          label: "Chave de busca",
        },
        {
          key: "scheduler",
          sortable: false,
          label: "Agendamento",
        },
        {
          key: "schedulerStatus",
          sortable: false,
          label: "Status do Agendamento",
        },
        {
          key: "active",
          sortable: false,
          label: "Ativo",
        },
      ],
      isBusy: false,
      id: 0,
      selectedChecklistId: null,
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
      checklist: {},
      hasAttachments: false,
      optionsBoolean: [
        { value: "true", text: "Sim" },
        { value: "false", text: "Não" },
        { value: "", text: "Todos" },
      ],
      statusOpt: [
        { value: "", text: "Todos" },
        { value: "Em aberto", text: "Em aberto" },
        { value: "Em digitação", text: "Em digitação" },
      ],
      tableFilters: {
        checklistId: "",
        active: "true",
        formName: "",
        dateFill: null,
        searchKey: "",
        scheduler: "",
        schedulerStatus: "",
      },
      showAllDraft: false,
    };
  },
  computed: {
    isUserAdmin() {
      return this.$store.getters.isAdministrator;
    },
    allowInactiveDraftFilter() {
      return this.$store.getters.allowInactiveDraftFilter;
    },
    computedFields() {
      if (this.allowInactiveDraftFilter) return this.fields;
      // hide the 'active' column when company setting disables the filter
      return this.fields.filter((f) => f.key !== "active");
    },
  },
  methods: {
    getFillUrl(checklist) {
      if (this.moduleId && this.moduleId > 0) {
        return `module/layout/draft${this.moduleId}/${checklist.formId}/${checklist.checklistId}`;
      }
      return `../../../Layout/form/Fill/${checklist.formId}/${checklist.checklistId}`;
    },
    getUserChangeUrl(checklist) {
      if (this.moduleId && this.moduleId > 0) {
        return `module/layout/draft${this.moduleId}/${checklist.checklistId}`;
      }
      return `/checklist/user/change/${checklist.checklistId}`;
    },
    deleteDraft() {
      if (!this.selectedChecklistId) return;
      this.$apiChecklist
        .get(`/checklist/delete/${this.selectedChecklistId}`)
        .then((response) => {
          console.log(response.data);
          this.alert.success = response.data.title;
          this.$refs.MyForm.refresh();
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(error.response);
          this.$refs.danger.msg =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
    reactivateDraft() {
      if (!this.selectedChecklistId) return;
      this.$apiChecklist
        .get(`/checklist/reactivate/${this.selectedChecklistId}`)
        .then((response) => {
          console.log(response.data);
          this.alert.success = response.data.title;
          this.$refs.MyForm.refresh();
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(error.response);
          this.$refs.danger.msg =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
    deleteDraftShowDialog(id) {
      this.selectedChecklistId = id;
      this.$refs.deleteDraftDialog.show();
    },
    reactivateDraftShowDialog(id) {
      this.selectedChecklistId = id;
      this.$refs.reactivateDraftDialog.show();
    },
    myProvider(ctx, callback) {
      this.isBusy = true;
      // console.log(ctx);
      let apiFilter = {
        currentPage: ctx.currentPage,
        perPage: (ctx.perPage = ctx.perPage),
        active: ctx.filter.active,
        checklistId: ctx.filter.checklistId,
        saveDate: ctx.filter.dateFill,
        formName: ctx.filter.formName,
        scheduler: ctx.filter.scheduler,
        searchKey: ctx.filter.searchKey,
        schedulerStatus: ctx.filter.schedulerStatus,
        IsAdmin: this.showAllDraft,
      };
      // console.log(this.formId);
      if (this.formId == undefined) this.id = 0;
      else this.id = this.formId;

      // console.log(this.showAllDraft);
      this.$apiChecklist
        .post("/checklist/v2/userdrafts/" + this.id, apiFilter)
        .then((response) => {
          const items = response.data.items;
          // console.log(response.data);
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
  },
  watch: {
    showAllDraft() {
      this.$refs.MyForm.refresh();
    },
  },
};
</script>

<style scoped>
.filterActive {
  min-width: 70px;
}
.table-buttons-desktop {
  display: none;
}
.table-buttons-mobile {
  display: block;
}
@media (min-width: 768px) {
  .table-buttons-desktop {
    display: block;
  }
  .table-buttons-mobile {
    display: none;
  }
}
</style>
